export default "__VITE_ASSET__Cm4JImrL__"